import { defineStore } from "pinia";
import { WhatsNewService } from "@/App/whatsNew/whatsNew.service";
import { useUserStore } from "@/App/user/user.store";

type WhatsNewStoreState = {
  showWhatsNew: boolean;
};

function shouldShowWhatsNew(whatsNewLastUpdateDate?: string, lastWhatsNewDate?: string): boolean {
  return !whatsNewLastUpdateDate || !lastWhatsNewDate || lastWhatsNewDate < whatsNewLastUpdateDate;
}
export const useWhatsNewStore = defineStore({
  id: "whatsNew",
  state: (): WhatsNewStoreState => ({
    showWhatsNew: false,
  }),
  actions: {
    getWhatsNewDate(): string {
      return WhatsNewService.whatsNewDate();
    },
    checkWhatsNew(lastWhatsNewDate?: string): void {
      const whatsNewLastUpdateDate = this.getWhatsNewDate();
      this.showWhatsNew = shouldShowWhatsNew(whatsNewLastUpdateDate, lastWhatsNewDate);
    },
    closeWhatsNew(): void {
      this.showWhatsNew = false;
    },
    async preventWhatsNew(): Promise<void> {
      const { user } = useUserStore();
      this.showWhatsNew = false;

      if (!user?.id) return;
      await WhatsNewService.setLastWhatsNewDate(user.id);
    },
  },
});
